import { showToast } from "../ui/toast";

export const buildInviteUrl = (projectUniqOrId) =>
    `https://www.buglog.app/invite/${projectUniqOrId}`;

export const buildInviteText = (_projectName, projectUniqOrId) => {
    const url = buildInviteUrl(projectUniqOrId);
    return `Sizi Buglog projeme davet ediyorum ${url}`;
};

export async function shareProjectInvite(projectName, projectUniqOrId, { silent = false } = {}) {
    const text = buildInviteText(projectName, projectUniqOrId);

    if (typeof navigator !== "undefined" && navigator.share) {
        try {
            await navigator.share({ text });
            if (!silent) {
                showToast({
                    title: "Paylaşıldı",
                    description: "Davet metni gönderildi.",
                    variant: "success"
                });
            }
            return { status: "success", method: "share", text };
        } catch (err) {
        }
    }

    try {
        if (navigator?.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
        } else {
            const ta = document.createElement("textarea");
            ta.value = text;
            ta.setAttribute("readonly", "");
            ta.style.position = "fixed";
            ta.style.opacity = "0";
            document.body.appendChild(ta);
            ta.select();
            document.execCommand("copy");
            document.body.removeChild(ta);
        }
        if (!silent) {
            showToast({
                title: "Bağlantı kopyalandı",
                description: "Davet metni panoya kopyalandı.",
                variant: "success"
            });
        }
        return { status: "success", method: "clipboard", text };
    } catch {
        if (!silent) {
            showToast({
                title: "Kopyalama başarısız",
                description: "Metni elle kopyalamanız gerekebilir.",
                variant: "error"
            });
        }
        return { status: "error" };
    }
}
